import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5df604d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "oxd-select-text--after" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes),
    style: _normalizeStyle(_ctx.style),
    onMousedown: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onToggle && _ctx.onToggle(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _mergeProps({
      class: "oxd-select-text-input",
      tabindex: _ctx.tabIndex,
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
    }, _ctx.$attrs, { ref: "oxdInput" }), _toDisplayString(_ctx.value), 17, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "afterInput", {}, undefined, true),
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_oxd_icon, {
            key: 0,
            name: _ctx.dropdownIcon,
            class: _normalizeClass(_ctx.dropdownIconClasses)
          }, null, 8, ["name", "class"]))
        : _createCommentVNode("", true)
    ])
  ], 38))
}